import * as ActionTypes from "../../constants/ActionTypes";

const initialState = {
    // Available slots
    availableSlots: [],
    slotsLoading: false,
    slotsError: null,
    
    // User appointments
    userAppointments: [],
    userAppointmentsLoading: false,
    userAppointmentsError: null,
    userAppointmentsPagination: {
        current_page: 1,
        total_pages: 1,
        total_appointments: 0,
        per_page: 10
    },
    
    
    // Selected appointment
    selectedAppointment: null,
    appointmentDetailsLoading: false,
    appointmentDetailsError: null,
    
    // Booking
    bookingLoading: false,
    bookingError: null,
    bookingSuccess: false,
    
    // Actions (cancel, confirm)
    actionLoading: false,
    actionError: null,
    actionSuccess: false,
    
    // Timezones
    timezones: [],
    timezonesLoading: false,
    timezonesError: null,
    
    // General
    loading: false,
    error: null
};

const appointmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Available Slots
        case ActionTypes.GET_AVAILABLE_SLOTS_REQUEST:
            return {
                ...state,
                slotsLoading: true,
                slotsError: null
            };
            
        case ActionTypes.GET_AVAILABLE_SLOTS_SUCCESS:
            return {
                ...state,
                slotsLoading: false,
                availableSlots: action.payload.available_slots || [],
                slotsError: null
            };
            
        case ActionTypes.GET_AVAILABLE_SLOTS_FAILURE:
            return {
                ...state,
                slotsLoading: false,
                availableSlots: [],
                slotsError: action.payload
            };
            
        // Book Appointment
        case ActionTypes.BOOK_APPOINTMENT_REQUEST:
            return {
                ...state,
                bookingLoading: true,
                bookingError: null,
                bookingSuccess: false
            };
            
        case ActionTypes.BOOK_APPOINTMENT_SUCCESS:
            return {
                ...state,
                bookingLoading: false,
                bookingError: null,
                bookingSuccess: true,
                // Add the new appointment to user appointments if they exist
                userAppointments: state.userAppointments.length > 0 ? 
                    [action.payload.appointment, ...state.userAppointments] : 
                    state.userAppointments
            };
            
        case ActionTypes.BOOK_APPOINTMENT_FAILURE:
            return {
                ...state,
                bookingLoading: false,
                bookingError: action.payload,
                bookingSuccess: false
            };
            
        // Get User Appointments
        case ActionTypes.GET_USER_APPOINTMENTS_REQUEST:
            return {
                ...state,
                userAppointmentsLoading: true,
                userAppointmentsError: null
            };
            
        case ActionTypes.GET_USER_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                userAppointmentsLoading: false,
                userAppointments: action.payload.appointments || [],
                userAppointmentsPagination: action.payload.pagination || initialState.userAppointmentsPagination,
                userAppointmentsError: null
            };
            
        case ActionTypes.GET_USER_APPOINTMENTS_FAILURE:
            return {
                ...state,
                userAppointmentsLoading: false,
                userAppointments: [],
                userAppointmentsError: action.payload
            };
            
        // Cancel Appointment
        case ActionTypes.USER_CANCEL_APPOINTMENT_REQUEST:
            return {
                ...state,
                actionLoading: true,
                actionError: null,
                actionSuccess: false
            };
            
        case ActionTypes.USER_CANCEL_APPOINTMENT_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                actionError: null,
                actionSuccess: true,
                // Update the appointment in user list
                userAppointments: state.userAppointments.map(apt => 
                    apt._id === action.payload.appointment._id ? action.payload.appointment : apt
                ),
                selectedAppointment: state.selectedAppointment && 
                    state.selectedAppointment._id === action.payload.appointment._id ? 
                    action.payload.appointment : state.selectedAppointment
            };
            
        case ActionTypes.USER_CANCEL_APPOINTMENT_FAILURE:
            return {
                ...state,
                actionLoading: false,
                actionError: action.payload,
                actionSuccess: false
            };
            
        // Get Appointment Details
        case ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST:
            return {
                ...state,
                appointmentDetailsLoading: true,
                appointmentDetailsError: null
            };
            
        case ActionTypes.GET_APPOINTMENT_DETAILS_SUCCESS:
            return {
                ...state,
                appointmentDetailsLoading: false,
                selectedAppointment: action.payload.appointment,
                appointmentDetailsError: null
            };
            
        case ActionTypes.GET_APPOINTMENT_DETAILS_FAILURE:
            return {
                ...state,
                appointmentDetailsLoading: false,
                appointmentDetailsError: action.payload
            };
            
        // Get Timezones
        case ActionTypes.GET_TIMEZONES_REQUEST:
            return {
                ...state,
                timezonesLoading: true,
                timezonesError: null
            };
            
        case ActionTypes.GET_TIMEZONES_SUCCESS:
            return {
                ...state,
                timezonesLoading: false,
                timezones: action.payload.timezones || [],
                timezonesError: null
            };
            
        case ActionTypes.GET_TIMEZONES_FAILURE:
            return {
                ...state,
                timezonesLoading: false,
                timezonesError: action.payload
            };
            
        // Set Selected Appointment
        case ActionTypes.SET_SELECTED_APPOINTMENT:
            return {
                ...state,
                selectedAppointment: action.payload
            };
            
        // Clear Selected Appointment
        case ActionTypes.CLEAR_SELECTED_APPOINTMENT:
            return {
                ...state,
                selectedAppointment: null,
                appointmentDetailsError: null
            };
            
        // Update Appointment in List
        case ActionTypes.UPDATE_APPOINTMENT_IN_LIST:
            return {
                ...state,
                userAppointments: state.userAppointments.map(apt => 
                    apt._id === action.payload._id ? action.payload : apt
                ),
                storeAppointments: state.storeAppointments.map(apt => 
                    apt._id === action.payload._id ? action.payload : apt
                )
            };
            
        // Remove Appointment from List
        case ActionTypes.REMOVE_APPOINTMENT_FROM_LIST:
            return {
                ...state,
                userAppointments: state.userAppointments.filter(apt => apt._id !== action.payload),
                storeAppointments: state.storeAppointments.filter(apt => apt._id !== action.payload)
            };
            
        // Set Loading States
        case ActionTypes.SET_APPOINTMENT_LOADING:
            return {
                ...state,
                loading: action.payload
            };
            
        case ActionTypes.SET_SLOTS_LOADING:
            return {
                ...state,
                slotsLoading: action.payload
            };
            
        // Clear Errors
        case ActionTypes.CLEAR_APPOINTMENT_ERRORS:
            return {
                ...state,
                error: null,
                slotsError: null,
                userAppointmentsError: null,
                storeAppointmentsError: null,
                appointmentDetailsError: null,
                bookingError: null,
                actionError: null,
                timezonesError: null
            };
            
        // Clear Success States
        case ActionTypes.CLEAR_APPOINTMENT_SUCCESS:
            return {
                ...state,
                actionSuccess: false,
                bookingSuccess: false
            };
            
        // Reset State
        case ActionTypes.RESET_APPOINTMENT_STATE:
            return {
                ...initialState
            };
            
        default:
            return state;
    }
};

export default appointmentsReducer;


